(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Initialize mobile drawer overlay and internal scrolling behaviors
      this.initMobileDrawer();
      
      // Initialize mobile dropdowns
      this.initMobileDropdowns();
    }
    
    initMobileDrawer() {
      const headerDrawer = document.querySelector('header-drawer');
      const menuItems = document.querySelector('.header__menu-items');
      const detailsToggle = document.getElementById('Details-menu-drawer-container');
      const backdrop = document.getElementById('menu-drawer-backdrop');
      const headerElement = this.header || document.querySelector('.section-header') || this;

      const closeDrawer = () => {
        if (headerDrawer && typeof headerDrawer.closeMenuDrawer === 'function') {
          const summary = detailsToggle ? detailsToggle.querySelector('summary') : null;
          headerDrawer.closeMenuDrawer(new MouseEvent('click'), summary || false);
        } else if (detailsToggle) {
          detailsToggle.removeAttribute('open');
          detailsToggle.classList.remove('menu-opening');
          document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
          headerElement.classList.remove('menu-open');
        }
      };

      const checkScreenSize = () => {
        if (window.innerWidth < 990) {
          if (headerDrawer) headerDrawer.style.display = '';
          if (menuItems) menuItems.style.display = 'none';
        } else {
          if (headerDrawer) {
            headerDrawer.style.display = 'none';
            if (detailsToggle && detailsToggle.hasAttribute('open')) {
              closeDrawer();
            }
          }
          if (menuItems) menuItems.style.display = 'flex';
        }
        this.updateHeaderBottomPosition();
      };

      // Backdrop click closes the drawer
      if (backdrop) {
        backdrop.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          closeDrawer();
        });
      }

      // Close on Escape key press
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && detailsToggle && detailsToggle.hasAttribute('open')) {
          closeDrawer();
        }
      });

      // Synchronize body scroll lock and header stacking state on details toggle
      if (detailsToggle) {
        detailsToggle.addEventListener('toggle', () => {
          if (detailsToggle.open) {
            this.updateHeaderBottomPosition();
            document.body.classList.add('overflow-hidden-mobile', 'overflow-hidden-tablet');
            headerElement.classList.add('menu-open');
          } else {
            document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
            headerElement.classList.remove('menu-open');
          }
        });
      }

      // Check screen size immediately and on resize
      checkScreenSize();
      window.addEventListener('resize', checkScreenSize);
      window.addEventListener('resize', this.updateHeaderBottomPosition.bind(this));
    }

    initMobileDropdowns() {
      const customToggles = document.querySelectorAll('.custom-mobile-toggle');
      
      customToggles.forEach(toggle => {
        const toggleDropdown = (e) => {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) {
              e.stopImmediatePropagation();
            }
          }
          
          const targetId = toggle.getAttribute('data-target');
          const submenu = document.getElementById(targetId);
          
          if (submenu) {
            const isOpen = submenu.classList.contains('open');
            
            // Close all other dropdowns
            document.querySelectorAll('.custom-mobile-submenu.open').forEach(menu => {
              if (menu !== submenu) {
                menu.classList.remove('open');
              }
            });
            document.querySelectorAll('.custom-mobile-toggle.open').forEach(btn => {
              if (btn !== toggle) {
                btn.classList.remove('open');
                btn.setAttribute('aria-expanded', 'false');
              }
            });
            
            // Toggle current dropdown
            if (!isOpen) {
              submenu.classList.add('open');
              toggle.classList.add('open');
              toggle.setAttribute('aria-expanded', 'true');
            } else {
              submenu.classList.remove('open');
              toggle.classList.remove('open');
              toggle.setAttribute('aria-expanded', 'false');
            }
          }
        };

        // Use capture phase to intercept click before parent listeners
        toggle.addEventListener('click', toggleDropdown, true);

        // Keyboard accessibility (Enter and Space)
        toggle.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown(e);
          }
        });
      });
    }

    setHeaderHeight() {
      const h = (this.header && this.header.offsetHeight) ? this.header.offsetHeight : (this.offsetHeight || 60);
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      this.updateHeaderBottomPosition();
    }

    updateHeaderBottomPosition() {
      const headerElement = this.header || document.querySelector('.section-header') || this;
      if (headerElement) {
        const rect = headerElement.getBoundingClientRect();
        const bottomPos = Math.max(0, Math.round(rect.bottom));
        document.documentElement.style.setProperty('--header-bottom-position', `${bottomPos}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.querySelector('header-drawer details[open]')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      document.querySelectorAll('.header__dropdown.is-open').forEach((d) => {
        d.classList.remove('is-open', 'is-closed');
        const t = d.querySelector('.header__dropdown-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      const headerWrap = document.querySelector('.header-wrapper') || document.querySelector('.section-header');
      if (headerWrap) headerWrap.classList.remove('menu-open');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
